import { GENERAL_URL_API } from "../../../urls";

export const verInstitutos = async () => {
  try {
    const formData = new FormData();
    
    const response = await fetch(`${GENERAL_URL_API}/arte/verInstitutos`, {
      method: "POST",
      credentials: 'include',
      body: formData,
    });

    const data = await response.json();
    
    if (data.status === 1) {
      return {
        status: true,
        data: data.data || [],
        info: "Institutos obtenidos exitosamente"
      };
    } else {
      return {
        status: false,
        data: [],
        info: data.info || "Error al obtener institutos"
      };
    }
  } catch (error) {
    console.error("Error en verInstitutos:", error);
    return {
      status: false,
      data: [],
      info: "Error de conexión al obtener institutos"
    };
  }
}; 